import * as React from 'react'

function BallIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M10.102 21.7996C9.33939 19.3589 10.0106 15.6138 12.0776 12.0336C14.1385 8.46408 17.0351 6.01419 19.5251 5.44469"
        stroke="white"
      />
      <path
        d="M11.4419 2C11.2615 3.94419 10.5157 6.2298 9.22539 8.46468C7.29156 11.8142 4.64751 14.1615 2.40133 14.7854"
        stroke="white"
      />
      <circle cx="12" cy="12" r="10" stroke="white" />
    </svg>
  )
}

export default BallIcon
